var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatabase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.59998 14.4V18C3.59998 19.9882 7.36078 21.6 12 21.6C16.6392 21.6 20.4 19.9882 20.4 18V14.4C20.4 16.3882 16.6392 18 12 18C7.36078 18 3.59998 16.3882 3.59998 14.4Z",
    fill: "#BFB8B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59998 8.39999V12C3.59998 13.9882 7.36078 15.6 12 15.6C16.6392 15.6 20.4 13.9882 20.4 12V8.39999C20.4 10.3882 16.6392 12 12 12C7.36078 12 3.59998 10.3882 3.59998 8.39999Z",
    fill: "#BFB8B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4 5.99999C20.4 7.98822 16.6392 9.59999 12 9.59999C7.36078 9.59999 3.59998 7.98822 3.59998 5.99999C3.59998 4.01177 7.36078 2.39999 12 2.39999C16.6392 2.39999 20.4 4.01177 20.4 5.99999Z",
    fill: "#BFB8B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/Database.bbfb8dd92f8229423c4c74119d08e82a.svg";
export { ForwardRef as ReactComponent };